export function* createCounter(start = 0, step = 1) {
    let num = start;
    while (true) {
        yield num;
        num += step;
    }
}
